<template>
	<div class="m-t-20">
    <div class="ovf-hd">
      <div class="fl">
        <el-select v-model="chartData.chartType" placeholder="请选择" @change="chartTypeChange">
          <el-option
            v-for="item in chartOptions"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="fl m-l-20">
        <el-button type="primary" @click="setChart()">配置图表</el-button>
      </div>
    </div>
    <div class="m-t-10 table-container">
      <barChartTable
        v-if="chartData.chartType == 10"
        :tableData="chartData.tableData">
      </barChartTable>
    </div>
  </div>
</template>
<script>
import barChartTable from './chartTables/barChartTable'
export default {
  name: 'chartTable',
  props: {
    showType: {
      type: String,
      default() {
        return ''
      }
    },
    listIndex: {
      type: Number,
      default() {
        return -1
      }
    },
    chartData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      chartOptions: [{
        label: '柱状图',
        value: 10
      }],
      barChartObj: {
        chartType: 10,
        time_unit: null,
        style: {
          width: '1000px',
          height: '400px'
        },
        // tooltip: {
        //   trigger: 'item',
        //   axisPointer: {
        //     type: 'shadow'
        //   }
        // },
        tableData: [{
          type: '横坐标',
          name: '',
          x_axis: '',
          barWidth: '',              // 柱宽
          x_axis_type: null
        }, {
          type: '纵坐标',
          name: '',
          calculate_type: 10,        // 10: 计量；20: 计数
          y_axis: ''
        }, {
          type: '系列',
          series: ''
        }]
      }
    }
  },
  methods: {
    chartTypeChange(item) {
      let config = null
      switch (item) {
        case 10:
          config = _.cloneDeep(this.barChartObj)
          break
      }
      this.$emit('setChartData', config)
    },
    setChart(index, item) {
      this.$emit('setChartConfig', this.listIndex)
    }
  },
  components: {
    barChartTable
  }
}
</script>


// WEBPACK FOOTER //
// chartTable.vue?72d716fc